import React from "react";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    minHeight: '100vh',
    padding: theme.spacing(2),
  },
  card: {
    padding: theme.spacing(3),
    borderRadius: 20,
    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
  },
  heading: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textAlign: 'center',
  },
  sectionTitle: {
    fontWeight: 600,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    color: '#667eea',
    borderLeft: '4px solid #667eea',
    paddingLeft: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(3, 0),
    background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
    height: '2px',
  },
  listItem: {
    paddingLeft: 0,
    marginBottom: theme.spacing(1),
  },
  listItemText: {
    '& .MuiListItemText-primary': {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
}));

const PrivacyPolicy = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h4" className={classes.heading}>
            Privacy Policy
          </Typography>
          {/* <Typography variant="body2" color="textSecondary" gutterBottom>
            Last Updated: 2nd Oct 2025
          </Typography> */}
          <Divider className={classes.divider} />

          <Typography variant="body1" paragraph>
            At <b>www.sriqr.com</b>, we respect your privacy and are committed
            to protecting your personal information. This Privacy Policy
            explains how we collect, use, and safeguard your data when you use
            our ticket sales application (“App”).
          </Typography>

          <Typography variant="h6" className={classes.sectionTitle}>
            1. Information We Collect
          </Typography>
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Personal Information: Mobile number, payment details." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Event-Related Data: Tickets purchased, events attended, transaction history." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Device & Usage Data: IP address, browser/app version, cookies, usage patterns." />
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.sectionTitle}>
            2. How We Use Your Information
          </Typography>
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="To process ticket purchases and payments." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="To provide customer support and resolve issues." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="To send booking confirmations, updates, or promotional offers (with your consent)." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="To improve our services and user experience." />
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.sectionTitle}>
            3. Sharing of Information
          </Typography>
          <Typography variant="body1" paragraph>
            We do not sell or rent your personal data. We may share information
            with:
          </Typography>
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Event organizers for ticket verification." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Payment gateways for secure transactions." />
            </ListItem>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Legal authorities if required by law." />
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.sectionTitle}>
            4. Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            We use industry-standard encryption and security measures to protect
            your information.
          </Typography>

          <Typography variant="h6" className={classes.sectionTitle}>
            5. Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            You may access, update, or delete your information at any time.
          </Typography>

          <Typography variant="h6" className={classes.sectionTitle}>
            6. Contact Us
          </Typography>
          <Typography variant="body1">
            For privacy-related queries, contact us at:{" "}
            <b>amar@srshta.com</b>
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default PrivacyPolicy;
